/* eslint-disable no-unused-vars */
import { ControllerModel } from "../_model/ControllerModel";
import { SingletonFlowchart } from "../_service/singletonFlowchart";
import { Bomb } from "./modelBomb";

class ControllerBomb extends ControllerModel {
    constructor() {
        super("ControllerBomb");

        this.setNewNode = (callback, location) => {
            let bomb = new Bomb(location);
            bomb.decorate(callback);

            this.addNode(bomb);
            SingletonFlowchart.SaveStatus();
        };

        this.loadNode = (node, callback) => {
            let bomb = new Bomb();
            bomb.copyFrom(node);
            bomb.decorate(callback);
            this.addNode(bomb);
        };

        this.getProperties = async (node) => {
            let n = new Bomb();
            await n.copyFrom(node);
            return n.data
        }

        this.getNode = (node) => {
            let n = new Bomb();
            n.copyFrom(node);
            return n
        }
    }
}

export { ControllerBomb };